

// EDIT_MENU_
export const EDIT_MENU_SAGA = "EDIT_MENU_SAGA";

// DELETE MENU
// FETCH MENU ITEM
export const FETCH_MENU_ITEM_SAGA = "FETCH_MENU_ITEM_SAGA";
export const FETCH_MENU_ITEM_SUCCESS = "FETCH_MENU_ITEM_SUCCESS";

// FETCH MENU SECTION
export const FETCH_MENU_SECTION_SAGA = "FETCH_MENU_SECTION_SAGA";
export const FETCH_MENU_SECTION_SUCCESS = "FETCH_MENU_SECTION_SUCCESS";
export const FETCH_MENU_SECTION_ERROR = "FETCH_MENU_SECTION_ERROR";

// FETCH MENU COLLECTIONS
export const FETCH_MENU_COLLECTIONS_SAGA = "FETCH_MENU_COLLECTIONS_SAGA";
export const FETCH_MENU_COLLECTIONS_SUCCESS = "FETCH_MENU_COLLECTIONS_SUCCESS";

// HANDLE COLLECTION 
export const HANDLE_COLLECTION_CLICK_SAGA = "HANDLE_COLLECTION_CLICK_SAGA";
export const HANDLE_COLLECTION_SUCCESS = "HANDLE_COLLECTION_SUCCESS";

// CLEAR MENU PRODUCT SECTION COLLECTION
export const CLEAR_MENU_COLLECTIONS_SECTIONS_PRODUCTS = "CLEAR_MENU_COLLECTIONS_SECTIONS_PRODUCTS";

export const EDIT_MENU_SECTION_SAGA = "EDIT_MENU_SECTION_SAGA";
export const SET_BTN_SUBMIT_IN_PROGRESS_STATUS = "SET_BTN_SUBMIT_IN_PROGRESS_STATUS";
// FETCH MENU PRODUCTS
export const FETCH_MENU_PRODUCTS_SAGA = "FETCH_MENU_PRODUCTS_SAGA";
export const FETCH_MENU_PRODUCTS_SUCCESS = "FETCH_MENU_PRODUCTS_SUCCESS";

// FETCH MENU PRODUCT
export const FETCH_MENU_PRODUCT_SAGA = "FETCH_MENU_PRODUCT_SAGA";
export const FETCH_MENU_PRODUCT_SUCCESS = "FETCH_MENU_PRODUCT_SUCCESS";

//LOADING MODE;
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";

//EDIT MENU PRODUCT REQUEST
export const EDIT_MENU_PRODUCT_SAGA = "EDIT_MENU_PRODUCT_SAGA";
export const CREATE_MENU_PRODUCT_SAGA = "CREATE_MENU_PRODUCT_SAGA";
export const DELETE_MENU_PRODUCT_SAGA = "DELETE_MENU_PRODUCT_SAGA";
export const DELETE_ALL_MENU_PRODUCT_SAGA = "DELETE_ALL_MENU_PRODUCT_SAGA";


// UPLOAD MENU PRODUCT IMAGE
export const UPLOAD_MENU_PRODUCT_IMAGE = "UPLOAD_MENU_PRODUCT_IMAGE";

export const EDIT_MENU_PRODUCT_WITHOUT_NAVIGATION_SAGA = "EDIT_MENU_PRODUCT_WITHOUT_NAVIGATION_SAGA";

//MATCH MENU
export const MATCH_MENU_REQUEST_SAGA = "MATCH_MENU_REQUEST_SAGA";
export const CLEAR_MENU_PRODUCT = "CLEAR_MENU_PRODUCT";

export const MATCH_MENU_SUCCESS = "MATCH_MENU_SUCCESS";

export const SET_CREATE_PRODUCT_ALERT_MODAL = "SET_CREATE_PRODUCT_ALERT_MODAL";

export const FETCH_DEFAULT_ATTRIBUTE_LIST_SAGA = "FETCH_DEFAULT_ATTRIBUTE_LIST_SAGA";
export const FETCH_DEFAULT_ATTRIBUTE_LIST_SUCCESS = "FETCH_DEFAULT_ATTRIBUTE_LIST_SUCCESS";
export const CHECK_MENU_VALIDATION_SAGA = "CHECK_MENU_VALIDATION_SAGA";

// ADD EXIST ATTRIBUTE GROUP 
export const ADD_EXIST_ATTRIBUTE_GROUPE_SAGA = "ADD_EXIST_ATTRIBUTE_GROUPE_SAGA";

// ADD COLLECTION
export const ADD_COLLECTION_SAGA = "ADD_COLLECTION_SAGA";

export const ADD_NEW_COLLECTION_SUCCESS = "ADD_NEW_COLLECTION_SUCCESS";

// DELETE COLLECTION
export const DELETE_COLLECTION_SAGA = "DELETE_COLLECTION_SAGA";

// UPDATE COLLECTION
export const UPDATE_COLLECTION_SAGA = "UPDATE_COLLECTION_SAGA";

// ADD CATEGORY
export const ADD_CATEGORY_SAGA = "ADD_CATEGORY_SAGA";

export const ADD_NEW_CATEGORY_SUCCESS = "ADD_NEW_CATEGORY_SUCCESS";

// DELETE CATEGORY
export const DELETE_CATEGORY_SAGA = "DELETE_CATEGORY_SAGA";

// WOLT RUN DISCOUNT
export const RUN_WOLT_DISCOUNT_SAGA = "RUN_WOLT_DISCOUNT_SAGA";